var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.departments, function(department, departmentIndex) {
        return [
          _c(
            "div",
            {
              key:
                "department_" +
                department.DEPARTMENT_ID +
                "_" +
                departmentIndex,
              staticClass: "panel panel-default"
            },
            [
              _c("div", { staticClass: "panel-heading dark clearfix" }, [
                _c(
                  "h3",
                  { staticClass: "panel-title" },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(department.DEPARTMENT_DESC) +
                        "\n\t\t\t\t\t"
                    ),
                    _c("font-awesome-icon", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: {
                            trigger: "hover click",
                            content: _vm.$t(
                              "MAIN_CONTENT.Required.tootTipMessage",
                              {
                                required: department.MAXIMUM_REQ_COURSES,
                                description: department.DEPARTMENT_DESC,
                                count: department.SELECTED_COUNT
                              }
                            )
                          },
                          expression:
                            "{ trigger: 'hover click', content: $t('MAIN_CONTENT.Required.tootTipMessage', { required: department.MAXIMUM_REQ_COURSES, description: department.DEPARTMENT_DESC, count: department.SELECTED_COUNT } ) }",
                          modifiers: { top: true }
                        }
                      ],
                      attrs: { icon: "info-circle" }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "panel-body no-padding" }, [
                _c(
                  "div",
                  { staticClass: "table-responsive no-overflow" },
                  [
                    _c(
                      "table-editable-list",
                      {
                        attrs: {
                          columns: _vm.columns,
                          "show-select": true,
                          "show-actions": false,
                          tableClass: {
                            "margin-bottom-0": true,
                            "no-border": true
                          }
                        }
                      },
                      [
                        _c("template", { slot: "select" }, [
                          _c("th", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.CourseRequestForms.actions"
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "template",
                          { slot: "data-row" },
                          [
                            _vm._l(department.COURSES, function(course, idx) {
                              return [
                                _c(
                                  "table-list-row",
                                  {
                                    key:
                                      "course_" + course.COURSE_ID + "_" + idx,
                                    attrs: {
                                      columns: _vm.columns,
                                      rowdata: course,
                                      rowIndex: idx,
                                      showActions: false,
                                      customTRClasses: _vm.getClasses(course)
                                    }
                                  },
                                  [
                                    _c("template", { slot: "select" }, [
                                      _c(
                                        "td",
                                        { staticClass: "toggle-fixed-width" },
                                        [
                                          _c("sapphire-toggle", {
                                            attrs: {
                                              disabled: _vm.isToggleDisabled(
                                                course,
                                                department
                                              ),
                                              ariaLabel: course.DISPLAY_TITLE
                                            },
                                            on: {
                                              input: function($event) {
                                                return _vm.$emit(
                                                  "dataChanged",
                                                  "required",
                                                  department,
                                                  course
                                                )
                                              }
                                            },
                                            model: {
                                              value: course.IS_SELECTED,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  course,
                                                  "IS_SELECTED",
                                                  $$v
                                                )
                                              },
                                              expression: "course.IS_SELECTED"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("template", { slot: "courseTitle" }, [
                                      _c(
                                        "td",
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(course.DISPLAY_TITLE) +
                                              "\n\t\t\t\t\t\t\t\t\t\t\t"
                                          ),
                                          !!course.COURSE_CATALOG_DESC
                                            ? [
                                                _c("font-awesome-icon", {
                                                  directives: [
                                                    {
                                                      name: "tooltip",
                                                      rawName:
                                                        "v-tooltip.right",
                                                      value: {
                                                        trigger: "hover click",
                                                        content:
                                                          course.COURSE_CATALOG_DESC
                                                      },
                                                      expression:
                                                        "{ trigger: 'hover click', content: course.COURSE_CATALOG_DESC}",
                                                      modifiers: { right: true }
                                                    }
                                                  ],
                                                  staticStyle: {
                                                    cursor: "pointer"
                                                  },
                                                  attrs: {
                                                    icon: "question-circle"
                                                  }
                                                })
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.getClasses(course)[
                                            "required-prereq"
                                          ]
                                            ? _c(
                                                "p",
                                                {
                                                  staticStyle: { color: "red" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.getCoursePreAssignedMessage(
                                                          course
                                                        )
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.getClasses(course)[
                                            "failed-prereq"
                                          ]
                                            ? _c(
                                                "p",
                                                {
                                                  staticStyle: { color: "red" }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.CourseRequestForms.failedPrerequisites"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.getClasses(course)["course-taken"]
                                            ? _c(
                                                "p",
                                                {
                                                  staticStyle: { color: "red" }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.CourseRequestForms.courseNonRepeat"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    ])
                                  ],
                                  2
                                )
                              ]
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.selectedCourseForm.SPECIAL_REQUEST_USE_FLG ===
                          "B" ||
                        _vm.selectedCourseForm.SPECIAL_REQUEST_USE_FLG === "R"
                          ? _c("template", { slot: "append-list" }, [
                              _c("tr", [
                                _c(
                                  "td",
                                  [
                                    _c("sapphire-toggle", {
                                      attrs: {
                                        ariaLabel:
                                          department.SPECIAL_REQUEST
                                            .DEPARTMENT_DESC
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.$emit(
                                            "dataChanged",
                                            "special",
                                            department,
                                            {}
                                          )
                                        }
                                      },
                                      model: {
                                        value:
                                          department.SPECIAL_REQUEST
                                            .IS_SELECTED,
                                        callback: function($$v) {
                                          _vm.$set(
                                            department.SPECIAL_REQUEST,
                                            "IS_SELECTED",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "department.SPECIAL_REQUEST.IS_SELECTED"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { attrs: { colspan: "2" } },
                                  [
                                    !_vm.selectedCourseForm
                                      .SPECIAL_REQUEST_LABEL
                                      ? _c("strong", [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.$t(
                                                  "MAIN_CONTENT.CourseRequestForms.specialRequestNotes"
                                                )
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t\t"
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("strong", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.selectedCourseForm
                                            .SPECIAL_REQUEST_LABEL
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    !_vm.selectedCourseForm.SPECIAL_REQUEST_DESC
                                      ? _c(
                                          "span",
                                          { staticStyle: { color: "red" } },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "MAIN_CONTENT.CourseRequestForms.chooseDesiredCourseInParenthese"
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticStyle: { color: "red" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.selectedCourseForm
                                            .SPECIAL_REQUEST_DESC
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    department.SPECIAL_REQUEST.IS_SELECTED ===
                                      "Y" &&
                                    _vm.selectedCourseForm
                                      .SPECIAL_REQUEST_NOTES_FLG === "Y"
                                      ? [
                                          _c("br"),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticStyle: {
                                                "font-weight": "normal"
                                              },
                                              attrs: {
                                                for:
                                                  "course_" +
                                                  department.DEPARTMENT_ID +
                                                  "_special"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "MAIN_CONTENT.CourseRequestForms.moreDetailWithColon"
                                                    )
                                                  ) +
                                                  " \n\t\t\t\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  department.SPECIAL_REQUEST
                                                    .SR_NOTES,
                                                expression:
                                                  "department.SPECIAL_REQUEST.SR_NOTES"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "text",
                                              name:
                                                "course_" +
                                                department.DEPARTMENT_ID +
                                                "_special",
                                              id:
                                                "course_" +
                                                department.DEPARTMENT_ID +
                                                "_special"
                                            },
                                            domProps: {
                                              value:
                                                department.SPECIAL_REQUEST
                                                  .SR_NOTES
                                            },
                                            on: {
                                              input: [
                                                function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    department.SPECIAL_REQUEST,
                                                    "SR_NOTES",
                                                    $event.target.value
                                                  )
                                                },
                                                function($event) {
                                                  return _vm.$emit(
                                                    "dataChanged",
                                                    "special",
                                                    department,
                                                    {}
                                                  )
                                                }
                                              ]
                                            }
                                          })
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ])
                            ])
                          : _vm._e()
                      ],
                      2
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }